import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {
  OdooFilaComercio, OdooFilaMaestro, OdooListaFiltro, OdooMovimiento, OdooOpcionComercio, OdooPaginaLista,
} from './odoo-maestros.models';
import { OdooRespuesta } from './odoo.models';

/** Listas de las pestañas Clientes y Comercios del panel de Odoo (paginadas en el servidor). */
@Injectable({ providedIn: 'root' })
export class OdooMaestrosService {
  private readonly base = `${environment.BASE_LA}/api/odoo`;
  private opciones$?: Observable<OdooOpcionComercio[]>;

  constructor(private http: HttpClient) {}

  private params(f: Partial<OdooListaFiltro>): HttpParams {
    let p = new HttpParams();
    const campos: [string, string | number | undefined][] = [
      ['q', f.q?.trim()], ['estado', f.estado], ['comercio', f.comercio], ['page', f.page], ['limit', f.limit],
    ];
    campos.forEach(([k, v]) => { if (v !== '' && v !== undefined && v !== null) p = p.set(k, String(v)); });
    return p;
  }

  clientes(f: OdooListaFiltro): Observable<OdooPaginaLista<OdooFilaMaestro>> {
    return this.http
      .get<OdooRespuesta<OdooPaginaLista<OdooFilaMaestro>>>(`${this.base}/clientes`, { params: this.params(f) })
      .pipe(map((r) => r.data));
  }

  comercios(f: OdooListaFiltro): Observable<OdooPaginaLista<OdooFilaComercio>> {
    return this.http
      .get<OdooRespuesta<OdooPaginaLista<OdooFilaComercio>>>(`${this.base}/comercios`, { params: this.params({ ...f, comercio: '' }) })
      .pipe(map((r) => r.data));
  }

  /** Opciones del filtro «Comercio»: se piden una sola vez por sesión. */
  opcionesComercio(): Observable<OdooOpcionComercio[]> {
    if (!this.opciones$) {
      this.opciones$ = this.http.get<OdooRespuesta<OdooOpcionComercio[]>>(`${this.base}/clientes/comercios`).pipe(
        map((r) => r.data),
        shareReplay({ bufferSize: 1, refCount: false }),
      );
    }
    return this.opciones$;
  }

  movimientosCliente(sourceId: string, limit = 5): Observable<OdooMovimiento[]> {
    return this.http
      .get<OdooRespuesta<OdooMovimiento[]>>(`${this.base}/clientes/${encodeURIComponent(sourceId)}/movimientos`, { params: { limit: String(limit) } })
      .pipe(map((r) => r.data));
  }
}
